import { render, staticRenderFns } from "./DarkLogo.vue?vue&type=template&id=6426163c&"
import script from "./DarkLogo.vue?vue&type=script&lang=js&"
export * from "./DarkLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports